// @flow

import { schema } from 'normalizr';

export const ENTITY_NAME = 'routeStageResults';

export default new schema.Entity(ENTITY_NAME);
